import { useCallback, useMemo } from 'react';

import { useGraphql } from '../graphql';
import { useLoad } from '../load';

// One submitted test of one of the clinician's patients, for its review: the
// patient for the header, and the attempt with its answers, scores, the
// clinician's notes and review state, and the patient's earlier submissions
// of it. data is undefined until the answer arrives or when it failed; error,
// retry and reload are useLoad's.
export function usePatientAttempt({ patientId, attemptId }) {
  const graphql = useGraphql();

  const read = useCallback(function() {
    return graphql({
      document: `query PatientAttempt($patientId: ID!, $attemptId: ID!) {
        patient(id: $patientId) { id firstName lastName connectedSince }
        patientAttempt(id: $attemptId) {
          id patientId submittedAt answered total note reviewedAt
          questionnaire { name version language items { position } options { value label } }
          subscales { name score }
          answers { position text value label note }
          earlier { id submittedAt reviewedAt }
        }
      }`,
      variables: { patientId, attemptId }
    });
  }, [ graphql, patientId, attemptId ]);

  const { data, error, retry, reload } = useLoad(read);

  return useMemo(function() {
    return { data, error, retry, reload };
  }, [ data, error, retry, reload ]);
}
